@use 'kci-design-lib/styles/variables.scss' as *;
.icon-container {
  display: flex;
  width: fit-content;
  height: fit-content;
  &:has(.icon.filled) {
    background-color: var(--surface-elevated-hover);
  }
  &:has(.icon.outline) {
    background-color: transparent;
  }
  &:has(.icon.x-large) {
    padding: 12px;
  }
  &:has(.icon.large) {
    padding: 12px;
  }
  &:has(.icon.medium) {
    padding: 10px;
  }
  &:has(.icon.small) {
    padding: 8px;
  }
  &:has(.icon.x-small) {
    padding: 6px;
  }
  &:has(.icon.xx-small) {
    padding: 4px;
  }
  &:has(.icon.square) {
    border-radius: 4px;
  }
  &:has(.icon.circle) {
    border-radius: 40px;
  }
  &:has(img) {
    &:has(.icon.outline) {
      padding: 0;
    }
  }
}
.icon {
  &.baseicon {
    filter: var(--icon-atom-filter, var(--filter-icon-neutral));
  }
  &.x-large {
    width: 32px;
    height: 32px;
  }
  &.large {
    width: 24px;
    height: 24px;
  }
  &.medium {
    width: 20px;
    height: 20px;
  }
  &.small {
    width: 16px;
    height: 16px;
  }
  &.x-small {
    width: 12px;
    height: 12px;
  }
  &.xx-small {
    width: 12px;
    height: 12px;
  }
}
.icon-container img.filled:not(.file):not(.socialmediaicon) {
  filter: var(--filter-icon-social-media);
}
.icon-container img.socialmediaicon.filled {
  filter: none;
}
.icon-container img.file {
  filter: none;
}
.baseicon.outline {
  filter: var(--icon-atom-filter, var(--filter-icon-outline));
}
.socialmediaicon.outline {
  filter: none;
}
[data-theme='dark'] {
  .icon-container img.baseicon.filled {
    filter: brightness(0) saturate(100%) invert(13%) sepia(15%) saturate(1858%)
      hue-rotate(188deg) brightness(93%) contrast(97%);
  }
  .icon-container img.socialmediaicon.filled[alt='Apple'],
  .icon-container img.socialmediaicon.outline[alt='Apple'] {
    filter: brightness(0) saturate(100%) invert(87%) sepia(6%) saturate(1231%)
      hue-rotate(182deg) brightness(107%) contrast(104%);
  }
  .icon-container img.socialmediaicon.filled {
    filter: none;
  }
  .socialmediaicon.outline {
    filter: none;
  }
}
